import "./Construction.scss";

export function Construction () {
    return (
        <section className="construction">
            <h1 className="construction__title">Under construction...</h1>
        </section>
    );
}